<div class="transferts col-lg-12 col-md-12 col-sm-12 col-xs-12">
	 <div class="panel"
	 	*ngFor="let metaTransfert of sortedMetasTransferts" 
	 	[class]="metaTransfert.class"
	 	>
		<div class="panel-heading">
			<h4>Transfert #{{ metaTransfert.transfert.id }} {{ etatSuffixes[metaTransfert.transfert.etat] }}</h4>
		</div>
		<div class="panel-body">
			<div class="row form-group">
				<div class="col-md-6 col-sm-6" >
					<label class="control-label" for="emetteur">Emetteur : </label>
					{{ metaTransfert.emetteur.lastName }} {{ metaTransfert.emetteur.firstName }}
				</div>	
				<div class="col-md-6 col-sm-6" >
					<label class="control-label" for="desinataire">Destinataire : </label>
					{{ metaTransfert.destinataire.lastName }} {{ metaTransfert.destinataire.firstName }} 
				</div>	
				<div class="col-md-6 col-sm-6">
					<label class="control-label" for="accesEntreprise">Etat : </label>
					{{ etatLabels[metaTransfert.transfert.etat] }}
				</div>	
				<div class="col-md-6 col-sm-6">
					<label class="control-label" for="accesNumero">Date de transfert : </label>
					{{ metaTransfert.date | localDateTimeToDate: false | date: ' le dd/MM/yyyy &agrave; HH:mm' }}
				</div>	
				<div class="col-md-6 col-sm-6">
					<label class="control-label" for="accesEntreprise">Type de transfert : </label>
					{{ (metaTransfert.transfert.parametrage) ? "Param&eacute;trage" : (metaTransfert.transfert.local) ? "Local" : "Distant"}}
				</div>
				<div class="col-md-6 col-sm-6">
					<label class="control-label" for="accesEntreprise">Responsabilit&eacute; : </label>
					{{ metaTransfert.transfert.responsabilite }}
				</div>
				<div class="col-md-12 col-sm-12">
					<label class="control-label" for="">P&eacute;rim&egrave;tre : </label>
					<div>
						<div *ngIf="metaTransfert.antennesCompletes">
							<span>Antenne(s) compl&egrave;te&nbsp;(s): <b>{{ metaTransfert.antennesCompletes }}</b></span>
						</div>
						<div *ngIf="metaTransfert.parcsComplets">
							<span>Parc(s) complet(s)&nbsp;: <b>{{ metaTransfert.parcsComplets }}</b></span>
						</div>
							
						<!-- Ouvrages individuels, par parc, puis sous-parc -->
						<div *ngIf="metaTransfert.parcsIncomplets && metaTransfert.parcsIncomplets.length > 0" >
							<span>Ouvrage(s)&nbsp;:&nbsp;</span>
							<div class="parc" *ngFor="let metaParc of metaTransfert.parcsIncomplets">
								<b>{{ metaParc.code}}</b>&nbsp;:
								<span>{{ getLabelOuvrages(metaParc.ouvrages) }}</span>
								<div class="sousParc" *ngFor="let metaSousParc of metaParc.sousParcs">
									- <b>{{ metaSousParc.code }}</b>&nbsp;:
									<span>{{ getLabelOuvrages(metaSousParc.ouvrages) }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>	
		</div>					
		<div class="form-group text-center">
			<button type="button"
				class="btn btn-default"
				*ngIf="metaTransfert.fermable"
				(click)="fermerTransfert(metaTransfert.transfert)"
				>
				Masquer
			</button>
			<button type="button"
				class="btn btn-default"
				*ngIf="metaTransfert.annulable"
				(click)="annulerTransfert(metaTransfert.transfert)"
				>
				Annuler
			</button>	
			<button type="button"
				class="btn btn-success"
				*ngIf="metaTransfert.acceptable"
				(click)="accepterTransfert(metaTransfert.transfert)"
				>
				Confirmer
			</button>
			<button type="button"
				class="btn btn-danger"
				*ngIf="metaTransfert.refusable"
				(click)="refuserTransfert(metaTransfert.transfert)"
				>
				Refuser
			</button>										
		</div>
	</div>
 </div>